import lazySizes from 'lazysizes';
import { mq_breakpoints } from '../utils/breakpoints';

// Lazysizes
lazySizes.cfg.lazyClass = 'lazyload';
lazySizes.cfg.customMedia = {
	...mq_breakpoints,
};
